// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__1mZBq","otherContract":"Textarea_otherContract__34GWI"};